module.exports = __webpack_public_path__ + "img/resources.8a493bf6.svg";